import API_BASE_URL from '../../config';
import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

import PropTypes from 'prop-types';
import {
  Container,
  Segment,
  Item,
  Divider,
  Button,
  Message,
  Form,
} from 'semantic-ui-react';
import mindImg from '../../images/mind.svg';

const Main = ({ startQuiz }) => {
  const [full_name, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone_number, setPhoneNumber] = useState('');
  const [company, setCompany] = useState('');
  const [role, setRole] = useState('');
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const [token, setToken] = useState('');
  const [isCompanyReadonly, setIsCompanyReadonly] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const companyParam = params.get("company");
    const tokenParam = params.get("token");
  
    if (companyParam) {
      setCompany(companyParam);
      setIsCompanyReadonly(true);
    }
  
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, [location.search]);
  
  
  const handleSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!full_name || !email) {
      alert("Lütfen isim ve e-posta alanlarını doldurun.");
      return;
    }
  
    if (!emailRegex.test(email)) {
      alert("Lütfen geçerli bir e-posta adresi girin.");
      return;
    }
  
    setProcessing(true);
    setError(null);
  
    // 🔥 Token + limit doğrulaması
    fetch(`${API_BASE_URL}/api/check-token-limit/?company=${company}&token=${token}`)
      .then(res => {
        if (!res.ok) {
          if (res.status === 403) {
            throw new Error("Geçersiz veya pasif bağlantı.");
          } else if (res.status === 429) {
            throw new Error("Bu şirket için form kullanım limiti dolmuştur.");
          } else {
            throw new Error("Token doğrulama başarısız.");
          }
        }
        return res.json();
      })
      .then(() => {
        // Token geçerliyse soruları çek
        return fetch(`${API_BASE_URL}/api/questions/`);
      })
      .then(res => res.json())
      .then(data => {
        const parsed = data.map((group, index) => ({
          id: group.id,
          question: group.title,
          order: typeof group.order === 'number' ? group.order : index,
          options: group.options.map(opt => opt.text),
          optionIds: group.options.map(opt => opt.id),
          rawOptions: group.options,
        }));
  
        // Quiz başlat
        startQuiz(parsed, {
          full_name,
          email,
          phone_number,
          company,
          role,
          token, // ✅ backend'e kayıt için gönderilecek
        });
      })
      .catch(err => {
        console.error(err);
        alert(err.message || "Bir hata oluştu.");
        setError(err);
      })
      .finally(() => setProcessing(false));
  };
  
  
  // const handleSubmit = () => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  //   if (!full_name || !email) {
  //     alert("Lütfen isim ve e-posta alanlarını doldurun.");
  //     return;
  //   }
  
  //   if (!emailRegex.test(email)) {
  //     alert("Lütfen geçerli bir e-posta adresi girin.");
  //     return;
  //   }
  
  //   setProcessing(true);
  //   setError(null);
  //   fetch(`${API_BASE_URL}/api/questions/`)
  //     .then(res => res.json())
  //     .then(data => {
  //       const parsed = data.map((group, index) => ({
  //         id: group.id,
  //         question: group.title,
  //         order: typeof group.order === 'number' ? group.order : index,
  //         options: group.options.map(opt => opt.text),
  //         optionIds: group.options.map(opt => opt.id),
  //         rawOptions: group.options,
  //       }));
  
  //       startQuiz(parsed, {
  //         full_name,
  //         email,
  //         phone_number,
  //         company,
  //         role,
  //         token
  //       });
  //     })
  //     .catch(err => setError(err))
  //     .finally(() => setProcessing(false));
  // };
  
  
  return (
    <Container>
      <Segment>
        <Item.Group divided>
          <Item>
            <Item.Image src={mindImg} />
            <Item.Content>
              <Item.Header><h1>Kişilik Analiz Testi</h1></Item.Header>
              {error && (
                <Message error>
                  <Message.Header>Error</Message.Header>
                  <p>{error.message}</p>
                </Message>
              )}
              <Divider />
              <Form>
                <Form.Input
                  label="Adınız Soyadınız"
                  placeholder="İsim Soyisim"
                  value={full_name}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
                <Form.Input
                  label="Email"
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Form.Input
                  label="Cep Telefonunuz"
                  placeholder="+90"
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <Form.Input
                  label="Şirket Adı"
                  placeholder="Şirket Adı..."
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  readOnly={isCompanyReadonly}
                />

                <Form.Input
                  label="Pozisyonunuz"
                  placeholder="Pozisyon......"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                />
                <Divider />
                <Button
                  primary
                  size="big"
                  icon="play"
                  labelPosition="left"
                  content={processing ? 'Loading...' : 'Başla'}
                  onClick={handleSubmit}
                  disabled={processing || !full_name || !email}
                />
              </Form>
            </Item.Content>
          </Item>
        </Item.Group>
      </Segment>
    </Container>
  );
};

Main.propTypes = {
  startQuiz: PropTypes.func.isRequired,
};

export default Main;
